import { ref } from 'vue';

export interface ConfirmDialogOptions {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmColor?: string;
  icon?: string;
  maxWidth?: string;
}

const isVisible = ref(false);
const options = ref<ConfirmDialogOptions>({
  title: '',
  message: '',
  confirmText: '削除',
  cancelText: 'キャンセル',
  confirmColor: 'error',
  icon: 'mdi-delete',
  maxWidth: '480px',
});

let resolvePromise: ((value: boolean) => void) | null = null;

export const useConfirmDialog = () => {
  const showConfirm = (
    dialogOptions: ConfirmDialogOptions
  ): Promise<boolean> => {
    options.value = {
      confirmText: '削除',
      cancelText: 'キャンセル',
      confirmColor: 'error',
      icon: 'mdi-delete',
      maxWidth: '480px',
      ...dialogOptions,
    };
    isVisible.value = true;

    return new Promise((resolve) => {
      resolvePromise = resolve;
    });
  };

  const confirm = () => {
    isVisible.value = false;
    resolvePromise?.(true);
    resolvePromise = null;
  };

  const cancel = () => {
    isVisible.value = false;
    resolvePromise?.(false);
    resolvePromise = null;
  };

  return {
    isVisible,
    options,
    showConfirm,
    confirm,
    cancel,
  };
};
